import { auth } from "./features/auth/Auth"
import { setUserAlias } from "./features/auth/userAliasSlice";

export const preLoad = async (dispatch) => {
    let userAlias = await auth(dispatch);
    dispatch(setUserAlias(userAlias));

}